const ColorVariants = Object.freeze({
  SUCCESS: "success",
  DANGER: "danger",
  SECONDARY: "secondary",
  INFO: "info",
  WARNING: "warning",
});

export default ColorVariants;
